import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { DocumentService, Document } from "app/services/document.service";
import { Router, ActivatedRoute, Params, ActivatedRouteSnapshot } from '@angular/router';
import { NgForm } from '@angular/forms';
import * as _ from 'underscore';

@Component({
    selector: 'app-document-selector',
    templateUrl: './document-selector.component.html',
    styleUrls: ['./document-selector.component.css']
})
export class DocumentSelectorComponent implements OnInit {
    documents: any;
    cur_document: Document;
    @Output() onSelect = new EventEmitter<Document>();
    docForm: NgForm;
    @ViewChild('docForm') currentForm: NgForm;
    error: any;
    success: any;
    q: string = '';
    private allItemsOri: Document[];

    constructor(
        private documentService: DocumentService,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.documentService.getDocuments().subscribe(documents => {
            this.documents = documents.sort((a, b) => {
                if (a.created_at == b.created_at) {
                    return 0;
                }
                return a.created_at > b.created_at ? -1 : 1;
            });
            this.documents = _.clone(this.documents);
            this.allItemsOri = _.clone(this.documents);
        });
    }

    docOnClick(document: Document) {
        this.cur_document = document;
    }

    select(document: Document) {
        this.onSelect.emit(document);
    }

    upload() {
        var uploader = document.getElementsByClassName('progress-bar')[0];
        var progress = document.getElementsByClassName('progress')[0];
        var target = (<HTMLInputElement>document.getElementById('document'));
        var file_name_element = <HTMLDivElement>document.getElementById("file-used");
        var fileLength = target.files.length;

        if (fileLength !== 0) {
            var pdf = target.files[0].type.match(/\.pdf|application\/pdf/);
        }

        if (fileLength === 0) {
            this.error = 'error';
        } else if (!pdf) {
            this.error = 'Please upload pdf file';
        } else {
            this.error = '';
            var selectedFile = target.files[0];
            var data = {
                selectedFile,
                uploader,
                progress,
                file_name_element
            }
            this.documentService.documentUpload(data);
            target.value = '';
        }
    }

    filechange(event: Event) {
        var input = <HTMLInputElement>event.target;
        console.log(input.files);
        var file_name_element = <HTMLDivElement>document.getElementById("file-used");
        var file = input.files[0];
        file_name_element.innerHTML = file.name;
        this.error = '';
    }

    onDelete(name, key) {
        if (confirm('Are you sure?')) {
            this.documentService.deleteDocument(name, key);
        }
    }

    filter_result() {
        if (this.q) {
            this.documents = this.allItemsOri.filter(item => {
                var regex = new RegExp(this.escapeRegExp(this.q), 'gi');

                var name = regex.test(item.name);

                return name;
            })
        }
        else {
            this.documents = this.allItemsOri;
        }
    }

    escapeRegExp(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/media/document/document-selector/document-selector.component.ts